import brandTheme from '../../../../Assets/Styles/brandTheme'
import { hexToRgbA } from './utils'

const { colors } = brandTheme()

const startColor = hexToRgbA(colors.primary, 0.1)
const endColor = hexToRgbA(colors.primary, 1)

export const chartOptions = {
  chart: {
    map: 'countries/us/us-all',
  },
  title: {
    text: '',
  },
  mapNavigation: {
    enabled: true,
  },
  credits: false,
  legend: {
    align: 'right',
    verticalAlign: 'bottom',
    layout: 'horizontal',
    floating: true,
    title: { text: 'Total sents %' },
  },

  colorAxis: {
    min: 0,
    max: 100,
    minColor: startColor,
    maxColor: endColor,
  },

  plotOptions: {
    map: {
      states: {
        hover: {
          color: '#EEDD66',
        },
      },
    },
  },
}
